var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"njdd-area"},[_c('h3',[_vm._v("农机调度系统")]),_c('div',{staticClass:"main-body"},[_c('div',{staticClass:"map-area"},[_c('MapViewer',{attrs:{"count":_vm.count},on:{"mapChange":_vm.mapChange}})],1),_c('div',{staticClass:"wdjs-area"},[_c('wdjs',{attrs:{"orderData":_vm.orderData},on:{"wdjsChange":_vm.wdjsChange}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }